import store from "../store-root";
import api from "../../service/api";

const moduleName = "dataDict";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //获取养殖类型
    async getCultureType() {
      let result = await api.get(`/api/DataDict?pid=3`);
      return result.data;
    },
    //获取渔种类型
    async getFishType() {
      let result = await api.get(`/api/DataDict?pid=4`);
      return result.data;
    },
    //获取养殖模式
    async getCultureMode() {
      let result = await api.get(`/api/DataDict?pid=1`);
      return result.data;
    },
    //损耗类型--损失原因
    async getReasonList() {
      let result = await api.get(`/api/DataDict?pid=5`);
      return result.data;
    },
    //获取用药时间
    async setUseMedicineTime() {
      let result = await api.get(`/api/DataDict?pid=6`);
      return result.data;
    },
    //获取用药方式
    async getUseMedicineWay() {
      let result = await api.get(`/api/DataDict?pid=8`);
      return result.data;
    },
    //获取水质参数种类
    async getParamsType() {
      let result = await api.get(`/api/DataDict?pid=9`);
      return result.data;
    },
    //获取养殖品种
    async getCultureBreed() {
      let result = await api.get(`/api/DataDict?pid=14`);
      return result.data;
    },
    //获取计量单位
    async getMeasurementUnit() {
      let result = await api.get(`/api/DataDict?pid=11`);
      return result.data;
    },
    //获取饲料类型
    async getFeedUnit() {
      let result = await api.get(`/api/DataDict?pid=12`);
      return result.data;
    },
    //获取渔药类型
    async getMedicineUnit() {
      let result = await api.get(`/api/DataDict?pid=13`);
      return result.data;
    },
    //获取渔肥类型
    async getGuanoUnit() {
      let result = await api.get(`/api/DataDict?pid=19`);
      return result.data;
    }
  }
});

export default moduleName;
